"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
class AlwaysCached {
    constructor(options) {
        this.LOCK_AWAIT_STEP = 50;
        this.LOCK_AWAIT_LIMIT = 30 * 1000;
        this.cache = options.cache;
        this.prefix = options.prefix || '';
        this.elementOptions = Object.assign({
            alwaysCached: true,
            renewOnGet: false,
            noExpire: false
        }, options.elementOptions || {});
        this.getterFunction = options.getterFunction;
        this.cachedGetterFunction = this.cache.wrapWithCache(this.getterFunction, this.elementOptions, {
            prefix: this.prefix
        });
        this.updateLocks = new Set();
        this.updateOnlyCached = !!(options.updateOnlyCached === undefined ? true : options.updateOnlyCached);
        if (options.LOCK_AWAIT_STEP) {
            this.LOCK_AWAIT_STEP = options.LOCK_AWAIT_STEP;
        }
        if (options.LOCK_AWAIT_LIMIT) {
            this.LOCK_AWAIT_LIMIT = options.LOCK_AWAIT_LIMIT;
        }
    }
    async get(key, ...args) {
        const prefixedKey = this.prefix + key;
        if (this.cache.alwaysCachedExpireListeners && !this.cache.alwaysCachedExpireListeners[prefixedKey]) {
            this.cache.alwaysCachedExpireListeners[prefixedKey] = {
                handler: () => this.update(key, ...args)
            };
        }
        return this.cachedGetterFunction(key, ...args);
    }
    async update(key, ...args) {
        const prefixedKey = this.prefix + key;
        if (this.updateOnlyCached && !await this.cache.has(prefixedKey)) {
            return;
        }
        if (!this.updateLocks.has(prefixedKey)) {
            this.updateLocks.add(prefixedKey);
            try {
                const result = await this.getterFunction(key, ...args);
                await this.cache.set(prefixedKey, result, this.elementOptions);
                return result;
            }
            catch (error) {
                this.cache.delete(prefixedKey);
            }
            finally {
                this.updateLocks.delete(prefixedKey);
            }
        }
        else {
            let tries = 0;
            while (this.updateLocks.has(prefixedKey) && tries < this.LOCK_AWAIT_LIMIT) {
                await utils_1.wait(this.LOCK_AWAIT_STEP);
                tries += this.LOCK_AWAIT_STEP;
            }
            if (this.updateLocks.has(prefixedKey)) {
                this.updateLocks.delete(prefixedKey);
                return this.update(key, ...args);
            }
            else {
                return await this.cache.get(prefixedKey);
            }
        }
        return;
    }
    async delete(key) {
        const prefixedKey = this.prefix + key;
        if (await this.cache.has(prefixedKey)) {
            this.cache.delete(prefixedKey);
            return true;
        }
        return false;
    }
}
exports.AlwaysCached = AlwaysCached;
exports.default = AlwaysCached;
//# sourceMappingURL=AlwaysCached.js.map